export const SHOPPING_CART_ITEMS_API = {
  publishShoppingCartItem: `api/cart-items`,
  getShoppingCartItems: (userId: number) => `api/users/${userId}/cart-items`,
  patchShoppingCartItem: (itemId: number) => `api/cart-items/${itemId}`,
  deleteShoppingCartItem: (itemId: number) => `api/cart-items/${itemId}`,
};

export type CartItem = {
  quantity: number;
  sku: string;
  userId: number;
  articleId: number;
  title: string;
  srcImage: string;
  characteristics: { prop: string; value: string; id: string }[];
};
